import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DynamicContentItem, DynamicContentComponent } from "../components/DynamicContentComponent";
import { ImageComponent } from "../components/ImageComponent";
import { getPath, Paths } from '../utils/paths';
import { DynamicTextHeader } from "../components/dynamiccontent/DynamicTextHeader";
import { BreadcrumbComponent, BreadCrumProps } from "../components/BreadcrumComponent";

export const About = () => {
  const { t, ready } = useTranslation("about");

  if (!ready) return "loading translations...";

  const breadCrums = t("breadcrums", { returnObjects: true }) as BreadCrumProps[];

  const dynamicContent = t("dynamicContent", { returnObjects: true }) as DynamicContentItem[]

  return (
    <>
      <ImageComponent
        imageSrc={`${getPath(Paths.IMAGES_MISC, false)}/small-desk-umbrella-coffe-small.jpg`}
        imageProps={{
          width: "100%",
          height: "auto"
        }}
      />
      <BreadcrumbComponent breadcrums={breadCrums} />
      <Box>
        <DynamicContentComponent
          items={dynamicContent}
          key={"about-us"}
        />
      </Box>
    </>
  );
};